module.exports = __webpack_public_path__ + "static/media/filename (7).e0a3dc0d.png";